module.exports = __webpack_public_path__ + "static/media/emailSubject.6e984a9d.txt";